export default __webpack_public_path__ + "static/media/logo.b8275bb4.png";